import { ContextualItemTypeVariant, useAPI } from '@nexelem/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../../../hooks';
import { productItemVariantsQueryKey } from './useProductItemVariants';

export const useToggleVariantStatus = (variant: ContextualItemTypeVariant, active: boolean, productName: string) => {
  const api = useAPI();
  const queryClient = useQueryClient();
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('products.detailsPage.variants');

  return useMutation({
    mutationFn: () =>
      api.postBackItemsVariants({
        contextualItemTypeVariant: {
          id: variant.id,
          itemTypeId: variant.itemTypeId,
          name: variant.name,
          properties: variant.properties,
          minimalAmount: variant.minimalAmount,
          active,
        },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productItemVariantsQueryKey(variant.itemTypeId) });
      displayToast({
        toastType: active ? 'success' : 'info',
        message: tWrapper(active ? 'toast.activated' : 'toast.deactivated', {
          productName,
          variantName: variant.name,
        }),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: active ? tWrapper('toast.activationError') : tWrapper('toast.deactivationError'),
      });
    },
  });
};
